'use strict';
module.exports = require('store2').namespace('groups');



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/utils/store.js
// module id = JOWb
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16